var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/heroicons-mini/arrow-right-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36ZM13.5 18.5C12.6716 18.5 12 19.1716 12 20C12 20.8284 12.6716 21.5 13.5 21.5H22.6802L18.4793 25.4008C17.8723 25.9645 17.8371 26.9136 18.4008 27.5207C18.9645 28.1277 19.9136 28.1629 20.5207 27.5992L27.5207 21.0992C27.8263 20.8154 28 20.4171 28 20C28 19.5829 27.8263 19.1846 27.5207 18.9008L20.5207 12.4008C19.9136 11.8371 18.9645 11.8723 18.4008 12.4793C17.8371 13.0864 17.8723 14.0355 18.4793 14.5992L22.6802 18.5H13.5Z",
    fill: "#232429"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.8f3c4c062eec9d651b88316962f2f7f7.svg";
export { ForwardRef as ReactComponent };